import { HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Sort } from '@angular/material/sort';
import { Params } from '@angular/router';

import { OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';

import { PaginationData, PaginationRange } from 'tiime-components';

import { TemporaryEncoder } from '@core/temporary-encoder';

export type FiltersParams = Params;

export class HttpHelper {
  static getListBody<T>(range: PaginationRange, body: T[]): T[] {
    if (body.length > range.max - range.min + 1) {
      body.pop();
    }
    return body;
  }

  static getRangeFromResponseHeaders(headers: HttpHeaders, pageSize: number): PaginationRange {
    const contentRange = headers.get('Content-Range');
    const range = PaginationRange.fromHttpResponseHeaders(contentRange, pageSize);

    return range;
  }

  static mapToPaginationData<T, R = any>(
    range: PaginationRange,
    mapJsonToEntity: (_: R) => T
  ): OperatorFunction<HttpResponse<R[]>, PaginationData<T>> {
    return map((response: HttpResponse<R[]>) => {
      const responseRange: PaginationRange = HttpHelper.getRangeFromResponseHeaders(response.headers, range.pageSize);
      const items: T[] = HttpHelper.getListBody(range, response.body ?? []).map(mapJsonToEntity);
      return new PaginationData(items, responseRange);
    });
  }

  static setRangeHeader(headers: HttpHeaders, range: PaginationRange): HttpHeaders {
    const maxRangePlusOne = new PaginationRange(range.min, range.max + 1);
    headers = headers.set('Range', maxRangePlusOne.toHttpRequestHeader());
    return headers;
  }

  static setSortParam(sort: Sort, params: HttpParams = HttpHelper.createHttpParams()): HttpParams {
    params = sort && sort.active && sort.direction ? params.set('sorts', HttpHelper.sortToString(sort)) : params;
    return params;
  }

  static sortToString(sort: Sort | string): string {
    if (typeof sort !== 'string') {
      return `${sort.active}:${sort.direction}`;
    }
    return sort;
  }

  static createHttpParams(): HttpParams {
    return new HttpParams({ encoder: new TemporaryEncoder() });
  }

  static toJsonId<T extends { id?: number }>(value: T | null | undefined): { id: number } | null {
    if (!value?.id) {
      return null;
    }

    return { id: value.id };
  }
}
